import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import Header from "./Header";

export default function NewsManager() {
  const { instance } = useMsal();
  const [news, setNews] = useState([]);
  const [selectedId, setSelectedId] = useState(null); // noticia seleccionada
  const [form, setForm] = useState({
    Title: "",
    Message: "",
    Type: "info",
    DateIni: "",
    DateFin: "",
    IsEnabled:1,
    IsPushed:false,
  });

   const servidor = "https://analytics-bi.azurewebsites.net";
  //const servidor = "http://localhost:3000";

  const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  };

  const userAuth = getAccountInfo();

  const user = {
    name: userAuth?.name || "Usuario desconocido",
    email: userAuth?.username || "email@desconocido.com",
  };

  // Cargar noticias
  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    const res = await axios.get(`${servidor}/api/news`);
    setNews(res.data);
  };

  // Crear o actualizar según corresponda
  const handleSubmit = async () => {
        if (selectedId) {
        // UPDATE
        await axios.put(`${servidor}/api/updatenews/${selectedId}`, { ...form });
        } else {
        // CREATE
        // Validaciones básicas
        if (!form.Title.trim()) {
            alert("El título es obligatorio");
            return;
        }
        if (!form.Message.trim()) {
            alert("El mensaje es obligatorio");
            return;
        }
        if (!form.DateIni) {
            alert("La fecha de inicio es obligatoria");
            return;
        }
        if (!form.DateFin) {
            alert("La fecha de fin es obligatoria");
            return;
        }

      await axios.post(`${servidor}/api/createnews`, { ...form, Type : form.Type ,IsEnabled: 1, IsPushed: form.IsPushed });
    }
    fetchNews();
    clearForm();
  };

  // Desactivar noticia
  const disableNews = async (id) => {
    await axios.patch(`${servidor}/api/desabilitarnews/${id}/disable`);
    fetchNews();
  };

  // Cuando doy clic en editar
  const handleEdit = (item) => {
    setSelectedId(item.Id);
    setForm({
      Title: item.Title,
      Message: item.Message,
      Type: item.Type,
      DateIni: item.DateIni ? item.DateIni.slice(0, 16) : "", // formato YYYY-MM-DDTHH:mm
      DateFin: item.DateFin ? item.DateFin.slice(0, 16) : "",
      IsEnabled: 1,
      IsPushed: item.IsPushed,
    });
  };

  // Limpiar formulario
  const clearForm = () => {
    setSelectedId(null);
    setForm({
      Title: "",
      Message: "",
      Type: "info",
      DateIni: "",
      DateFin: "",
      IsEnabled: 1
    });
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      //postLogoutRedirectUri: "http://localhost:3000",
      postLogoutRedirectUri: "https://analytics.centenario.com.pe",
    });
  };

  return (
    <>
      <Header user={user} onLogout={handleLogout} />

      <div className="container" style={{ maxHeight: "90vh", overflowY: "auto" }}>
        <div className="row">
          <div className="col-12">
            {/* Noticias */}
            <div className="p-4">
              <h2 className="text-xl font-bold">Gestión de Anuncios</h2>

              {/* Formulario */}
              <div className="mb-4">
                <div className="mb-3">
                    <label className="form-label">Título</label>
                    <input
                    type="text"
                    className="form-control"
                    value={form.Title}
                    onChange={(e) => setForm({ ...form, Title: e.target.value })}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Mensaje</label>
                    <textarea
                    className="form-control"
                    value={form.Message}
                    onChange={(e) => setForm({ ...form, Message: e.target.value })}
                    ></textarea>
                </div>

                <div className="row mb-3">
                    <div className="col">
                    <label className="form-label">Fecha Inicio</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        value={form.DateIni}
                        onChange={(e) => setForm({ ...form, DateIni: e.target.value })}
                    />
                    </div>
                    <div className="col">
                    <label className="form-label">Fecha Fin</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        value={form.DateFin}
                        onChange={(e) => setForm({ ...form, DateFin: e.target.value })}
                    />
                    </div>
                </div>

                <div className="mb-3">
                    <label className="form-label">Tipo</label>
                    <select
                    className="form-select"
                    value={form.Type}
                    onChange={(e) => setForm({ ...form, Type: e.target.value })}
                    >
                    <option value="success">Informativo</option>
                    <option value="error">Error</option>
                    <option value="important">Importante</option>
                    </select>
                </div>

                 <div className="mb-3">
                    <input
                        type="checkbox"
                        checked={form.IsPushed}
                        onChange={(e) =>
                        setForm({ ...form, IsPushed: e.target.checked })
                        }
                    />
                    <span className="ml-2">Notificación Push</span>
                </div>

                <button onClick={handleSubmit} className="btn btn-primary me-2">
                    {selectedId ? "Actualizar" : "Crear"}
                </button>
                {selectedId && (
                    <button onClick={clearForm} className="btn btn-secondary">
                    Cancelar
                    </button>
                )}
                </div>
              {/* Fin Formulario */}
              {/* Tabla de noticias */}
              <div style={{ maxHeight: "30vh", overflowY: "auto" }}>
                <table className="w-full border">
                    <thead className="sticky top-0 bg-gray-200">
                    <tr>
                        <th>ID</th>
                        <th>Título</th>
                        <th>Mensaje</th>
                        <th>Tipo</th>
                        <th>Pushed</th>
                        <th>Fecha Ini</th>
                        <th>Fecha Fin</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                    {news.map((n) => (
                        <tr key={n.Id} className="border-b">
                        <td>{n.Id}</td>
                        <td>{n.Title}</td>
                        <td>{n.Message}</td>
                        <td>{n.Type}</td>
                        <td>{n.IsPushed == 1 ? "Sí" : "No"}</td>
                        <td>{new Date(n.DateIni).toLocaleString()}</td>
                        <td>{new Date(n.DateFin).toLocaleString()}</td>
                        <td>{n.IsEnabled == 1 ? "Activo" : "Inactivo"}</td>
                        <td>
                            <button
                            onClick={() => handleEdit(n)}
                            className="bg-yellow-500 text-white px-2 py-1 rounded mr-2"
                            style={{ width: "85px", fontSize: "8pt" }}
                            >
                            Editar
                            </button>
                            <button
                            onClick={() => disableNews(n.Id)}
                            className="bg-red-500 text-white px-2 py-1 rounded"
                            style={{ width: "85px", fontSize: "8pt" }}
                            >
                            Desactivar
                            </button>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
